export const outreachStatus = {
  active: {
    value: 'Active',
    color: 'pastel-2-dark',
    bg: 'pastel-2-light',
  },
  draft: {
    value: 'Draft',
    color: 'pastel-6-dark',
    bg: 'pastel-6-light',
  },
  paused: {
    value: 'Paused',
    color: 'pastel-1-dark',
    bg: 'pastel-1-light',
  },
  completed: {
    value: 'Completed',
    color: 'pastel-4-dark',
    bg: 'pastel-4-light',
  },
  archived: {
    value: 'Archived',
    color: 'pastel-5-dark',
    bg: 'pastel-5-light',
  },
};
